import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppFlyoutAnchor, createGeneratedMenuItem } from 'owa-command-ribbon';
import Checkmark from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import type ImportanceType from 'owa-service/lib/contract/ImportanceType';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import { importance_ActionControl } from '../../utils/actionControlStrings.locstring.json';
import loc from 'owa-localize';
import Important from 'owa-fluent-icons-svg/lib/icons/ImportantRegular';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';

const controlList = new Map<ActionControlId, ImportanceType>([
    [ActionControlId.HighImportance, 'High'],
    [ActionControlId.LowImportance, 'Low'],
    [ActionControlId.NormalImportance, 'Normal'],
]);

const getImportanceSectionControl = (
    selected: ImportanceType,
    editorId: string,
    setImportance: (label: ImportanceType) => void,
    styles: IButtonStyles | undefined
) => {
    const controls: MenuItemControlProps[] = [];
    controlList.forEach((importanceType, controlId) => {
        controls.push(
            createGeneratedMenuItem(
                getComposeRibbonId(controlId, editorId),
                loc(importanceType),
                () => setImportance(importanceType),
                undefined /* keytipProps */,
                selected === importanceType ? Checkmark : undefined,
                undefined /* iconColor */,
                styles
            )
        );
    });
    return controls;
};

const getImportanceSections = (
    importanceSelected: ImportanceType,
    editorId: string,
    setImportance: (label: ImportanceType) => void,
    styles: IButtonStyles | undefined
) => {
    const importanceSections: MenuSection[] = [];
    importanceSections.push({
        controls: getImportanceSectionControl(importanceSelected, editorId, setImportance, styles),
    });
    return importanceSections;
};

export const getImportance = computedFn(
    (
        editorId: string,
        importanceSelected: ImportanceType,
        setImportance: (label: ImportanceType) => void,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(importance_ActionControl);
        return createAppFlyoutAnchor(
            getComposeRibbonId(ActionControlId.SetImportance, editorId),
            label,
            {
                sections: getImportanceSections(
                    importanceSelected,
                    editorId,
                    setImportance,
                    styles
                ),
            },
            undefined /* keytipProps */,
            Important,
            undefined /* iconColor */,
            styles,
            {
                customTooltop: getHoverTooltip(ActionControlId.SetImportance, label),
            }
        );
    }
);
